import { useState, useEffect } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
import 'animate.css';
import TrackVisibility from "react-on-screen";
import { HashLink } from 'react-router-hash-link';
import {
  BrowserRouter as Router
} from "react-router-dom";

export const Banner = () => {
  const [loopNum, setLoopNum] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);
  const [text, setText] = useState('');
  const [delta, setDelta] = useState(300 - Math.random() * 100);
  const [index, setIndex] = useState(1);
  const toRotate = [ "Backend Web Developer", "Fullstack Web Developer" ];
  const period = 2000;

  useEffect(() => {
    let ticker = setInterval(() => {
      tick();
    }, delta)

    return () => { clearInterval(ticker) };
  }, [text])

  const tick = () => {
    let i = loopNum % toRotate.length;
    let fullText = toRotate[i];
    let updatedText = isDeleting ? fullText.substring(0, text.length - 1) : fullText.substring(0, text.length + 1);

    setText(updatedText);

    if (isDeleting) {
      setDelta(prevDelta => prevDelta / 2)
    }

    if (!isDeleting && updatedText === fullText) {
      setIsDeleting(true);
      setIndex(prevIndex => prevIndex - 1);
      setDelta(period);
    } else if (isDeleting && updatedText === '') {
      setIsDeleting(false);
      setLoopNum(loopNum + 1);
      setIndex(1);
      setDelta(500);
    } else {
      setIndex(prevIndex => prevIndex + 1);
    }
  }

  return (
    <Router>
    <section className ="banner" id="home">
      <Container>
        <Row className="align-items-center">
          <Col xs={12} md={6} xl={7}>
            <TrackVisibility>
            {({ isVisible}) =>
              <div  className={isVisible ? "animate__animated animate__fadeInLeft animate__repeat-1 animate__slow" : ""}>
                <span className="tagline">Welcome to my Portfolio</span>
                <div className="title">
                  <h1>{`Hi I'm Pedro, a `} <span className="txt-rotate" dataPeriod="1000" data-rotate='[ "Backend Web Developer", "Fullstack Web Developer" ]'><span className="wrap">{text}</span></span></h1>
                </div>
                <p>I'm from the beautiful city of Porto, Portugal. Recently I completed Le Wagon Web Development Bootcamp.</p>
                <p> Although I have a Master's Degree in Mine Engineering, I have found more joy in programming and bringing ideas to life.</p>
                <HashLink to='#connect' style={{ textDecoration: 'none' }}>
                  <button>Let's connect <ArrowRightCircle size={25} /></button>
                </HashLink>
              </div>}
            </TrackVisibility>
          </Col>
          <Col xs={12} md={6} xl={5}>
          <TrackVisibility>
            {({ isVisible}) =>
              <div className={isVisible ? "animate__animated animate__zoomInLeft animate__repeat-1 animate__slow" : ""}>
                <img src={headerImg} alt="Header Img" />
              </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
    </Router>
  )
}
